module.exports = __webpack_public_path__ + "static/media/t_big_01.5d92328e.png";